import { Briefcase } from "lucide-react";

const StaffTileDesign = {
  id: "staff",
  icon: Briefcase,
  label: "Staff",
  background: "linear-gradient(135deg, var(--color-primary-dark), var(--color-primary))",
  color: "#ffffff",
};

export default StaffTileDesign;
